import useBranchId from "@/shared/hooks/useBranchId";
import useSendWaiterCord from "@/shared/queries/waiter/useSendWaiterCord";
import { useEffect } from "react";

const CHECK_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes

const WaiterGlobal = () => {
  const { check } = useSendWaiterCord();
  const branchId = useBranchId();

  useEffect(() => {
    const run = () => check();
    run();
    const interval = setInterval(run, CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [branchId]);

  return <></>;
};

export default WaiterGlobal;
